import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'
import { useRootStore } from 'stores/RootStore'
import { Action, ActionProps } from './Action'
import { PlagiarismCheck as PlagiarismCheckIcon } from 'blaze-ui/icons/36'

import { useTierUsageLimits } from 'hooks/useTierUsageLimits'
import { useModals } from 'almanac-ui/Modal'
import { TierUpgradeModal } from 'components/TierUpgradeModal/TierUpgradeModal'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { FileCheck02 } from 'blaze-ui/icons/16'

export const PlagiarismCheck = observer(function PlagiarismCheck(props: ActionProps) {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const rightRailPanelStore = useRootStore().rightRailPanelStore
  const docStore = useDocStore()
  const { openModal } = useModals()
  const { atLimit, nextTierPlan, currentTierPlan } = useTierUsageLimits({ limitKey: 'plagiarism_checks' })
  const shouldEnforceTierLimit = atLimit && nextTierPlan && currentTierPlan

  const handleClick = () => {
    docStore?.rightRailStore.setActiveTab(undefined)
    rightRailPanelStore.show('plagiarism')
  }

  const handleLimitWrappedClick = () => {
    if (shouldEnforceTierLimit) {
      openModal(TierUpgradeModal, {
        reason: 'limit_reached',
        feature: 'Plagiarism Checks',
        upgradeTier: nextTierPlan,
        currentTier: currentTierPlan,
        onUpgrade: handleClick,
      })
    } else {
      handleClick()
    }
  }

  return (
    <Action
      icon={isSystemRedesignEnabled ? FileCheck02 : PlagiarismCheckIcon}
      upgradeBadge={shouldEnforceTierLimit ? <PricePill plan={nextTierPlan.key} /> : undefined}
      onPress={handleLimitWrappedClick}
      {...props}
    />
  )
})
